module.exports = __webpack_public_path__ + "media/images/logos/horizontal-navy-1f9230bfb3209227ef9132532a6dffc2.svg";